import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { CheckTemplateVersionResData } from "./CheckTemplateVersionResData";

const ENDPOINT = "/caosconfiguration/template/checkversion";

export class CheckTemplateVersionCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: CheckTemplateVersionReqData;

    constructor(payload: CheckTemplateVersionReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<CheckTemplateVersionResData> {
        let res = await this.executeCommand(this.payload);
        return new CheckTemplateVersionResData(res);
    }
}

export class CheckTemplateVersionReqData {
    installationNames: Array<string>;
    templateId: number;
    constructor(other: string[], templateId: number) {
        this.installationNames = other;
        this.templateId = templateId;
    }
}
